var resources = require('itemsViewStrings');
    var strings = resources['_n4Ol9K/KsxcPaSoc+Prd8g'];
export { strings };
export default strings;
